import React from "react";

export type TextAreaProps = {
  onChange?: (value: string) => void;
  value?: string;
};

export const TextArea = ({ onChange, value = "" }: TextAreaProps) => {
  return (
    <div className="gpc__text-area">
      <textarea onChange={(e) => onChange?.(e.target.value)} value={value} />
    </div>
  );
};

export default TextArea;
